<template>
	<div class="row">
		<div class="col-3 form-group">
			<label for="saturday">{{ $t("monte.congelation.saturday") }}</label>
			<b-form-checkbox v-model="form.semenceexpedition_saturday" id="saturday" />
		</div>
		<div class="col-3 form-group">
			<label for="invoice_group">{{ $t("monte.congelation.invoice_group") }}</label>
			<b-form-checkbox v-model="form.semenceexpedition_invoice_group" id="invoice_group" />
		</div>
		<div class="col-12 form-group">
			<label for="commentaire">{{ $t("monte.congelation.commentaire") }}</label>
			<e-editor-froala
				v-if="commentaire_loaded"
				identifier="semenceexpedition_commentaire"
				:placeholder="getTrad('monte.congelation.commentaire')"
				:content="commentaire"
				@change="updateCommentaire"
				:moreText="[ 'bold', 'italic', 'strikeThrough', 'underline', 'undo', 'redo', 'formatUL', 'formatOL', 'clearFormatting' ]"
			></e-editor-froala>
		</div>
		<div class="col-12 text-center">
			<a class="btn btn-primary mt-3" href="#" @click.prevent="checkForm(false)">{{ $t('action.modifier') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /></a>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
	import Shutter from '@/mixins/Shutter.js'

	export default {
		name: 'EditQuickCommande',
		mixins: [Congelation, Shutter],
		props: ['expedition'],
		data () {
			return {
				form: {
					semenceexpedition_commentaire: '',
					semenceexpedition_invoice_group: false,
					semenceexpedition_saturday: false
				},
				commentaire: '',
				processing: false,
				commentaire_loaded: false
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.form.semenceexpedition_commentaire = this.expedition.semenceexpedition_commentaire
				this.commentaire = this.expedition.semenceexpedition_commentaire
				this.form.semenceexpedition_invoice_group = this.expedition.semenceexpedition_invoice_group
				this.form.semenceexpedition_saturday = this.expedition.semenceexpedition_saturday
				this.commentaire_loaded = true
			},

			async checkForm(and_new = false) {
				let params = {
					semenceexpedition_commentaire: this.form.semenceexpedition_commentaire,
					semenceexpedition_invoice_group: this.form.semenceexpedition_invoice_group,
					semenceexpedition_saturday: this.form.semenceexpedition_saturday
				}

				this.processing = true
				await this.editExpeditionQuick(this.expedition.semenceexpedition_id, params)
				this.processing = false
				this.successToast('toast.info_save_succes')
				this.ok()
				this.shutterPanel().keepFirst()
			},

			updateCommentaire(val) {
				this.form.semenceexpedition_commentaire = val.val
			},
		}
	}

</script>